/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { StatsigProvider } from '@coursera-web/statsig';

import { Grid } from '@coursera/cds-core';

import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import HelpDropdownGridItem from 'bundles/composable-page-header/components/HelpDropdownGridItem';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import LanguageDropdownLegacyGridItem from 'bundles/composable-page-header/components/grid-items/LanguageDropdownLegacyGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import useShouldShowHelpDropdown from 'bundles/composable-page-header/hooks/useShouldShowHelpDropdown';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

const styles = {
  nav: css`
    justify-content: space-between;
    align-items: center;
  `,
  iconGroup: css`
    display: flex;
    align-items: center;
  `,
};

const ClipsEmbeddedExperienceHeaderNav = () => {
  const shouldShowHelpDropdown = useShouldShowHelpDropdown();

  return (
    <MainNavigationWrapper>
      <Grid container wrap="nowrap" css={styles.nav}>
        <Grid item>
          {/* No href — this component only renders when embedded, and the logo must never link out. */}
          <HomeLogoGridItemModule logos={[<CourseraHomeLogo key="coursera-home-logo" />]} />
        </Grid>
        <Grid item css={styles.iconGroup}>
          {shouldShowHelpDropdown && <HelpDropdownGridItem disableChatSsr={true} />}
          <LanguageDropdownLegacyGridItem useIconButton />
        </Grid>
      </Grid>
    </MainNavigationWrapper>
  );
};

const ClipsEmbeddedExperienceHeader = () => (
  <GlobalPageHeaderContainer
    desktopMainNav={<ClipsEmbeddedExperienceHeaderNav />}
    mobileMainNav={<ClipsEmbeddedExperienceHeaderNav />}
  />
);

const ClipsEmbeddedExperienceHeaderWithProvider = () => (
  <StatsigProvider>
    <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={0}>
      <ClipsEmbeddedExperienceHeader />
    </GlobalPageHeaderStateProvider>
  </StatsigProvider>
);

export default ClipsEmbeddedExperienceHeaderWithProvider;
